module.exports = __webpack_public_path__ + "media/images/favicon-a2a709d5b9e9e302df707576a69b5fe5.ico";